<template>
  <div class="application-form-container" v-loading="loading">
    <div class="form-header">
      <h2>申请表单</h2>
      <p>请详细填写以下信息</p>
    </div>

    <!-- 
      el-form 属性说明:
      :model="formData" -> 数据双向绑定对象
      :rules="rules"    -> 校验规则对象
      ref="appForm"     -> 用于JS中调用校验方法
      label-position="top" -> 标签在输入框上方，适合长文本题目
    -->
    <el-form :model="formData" :rules="rules" ref="appForm" label-position="top" size="medium">

      <!-- 1. 申请动机 -->
      <el-form-item label="1. 申请动机" prop="motivation">
        <el-input type="textarea" v-model="formData.motivation" :rows="4" placeholder="请描述您申请该专业/职位的初衷和动力..."
          maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <!-- 2. 相关的学术和经验要求 -->
      <el-form-item label="2. 相关的学术和经验要求" prop="experience">
        <el-input type="textarea" v-model="formData.experience" :rows="4" placeholder="请阐述您目前具备的学术背景及相关经验..."
          maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <!-- 3. 个人的过去与申请专业的关联性 -->
      <el-form-item label="3. 个人的过去与申请专业的关联性" prop="relevance">
        <el-input type="textarea" v-model="formData.relevance" :rows="4" placeholder="请分析您的过往经历与该专业的联系..."
          maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <!-- 4. 职业规划 -->
      <el-form-item label="4. 职业规划" prop="careerPlan">
        <el-input type="textarea" v-model="formData.careerPlan" :rows="4" placeholder="请简述您的短期及长期职业发展规划..."
          maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <!-- 5. 社会贡献 -->
      <el-form-item label="5. 社会贡献" prop="contribution">
        <el-input type="textarea" v-model="formData.contribution" :rows="4" placeholder="请描述您期望带来的社会价值或贡献..."
          maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <!-- 操作按钮 -->
      <!-- <el-form-item class="form-footer">
        <el-button type="primary" @click="submitForm('appForm')">提交申请</el-button>
        <el-button @click="resetForm('appForm')">重置</el-button>
      </el-form-item> -->
    </el-form>
    <HBFixedButton desc="_" @click="submitForm('appForm')" />
  </div>
</template>

<script>
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import { getUserInfoApi,updateUserInfoApi } from '@/api/mycenter_studyabroad.js';
export default {
  name: 'ApplicationForm',
  components: {
    HBFixedButton
  },
  data() {
    return {
      loading:false,
      type: 'phd_1',
      // 1. 参数绑定：这里对应表单的五个字段
      formData: {
        motivation: '',   // 申请动机
        experience: '',   // 学术和经验
        relevance: '',    // 过去与专业的关联
        careerPlan: '',   // 职业规划
        contribution: ''  // 社会贡献
      },
      // 2. 校验规则
      rules: {
        motivation: [
          { required: true, message: '请填写申请动机', trigger: 'blur' },
          { min: 10, message: '内容不能少于10个字', trigger: 'blur' }
        ],
        experience: [
          { required: true, message: '请填写相关的学术和经验要求', trigger: 'blur' }
        ],
        relevance: [
          { required: true, message: '请分析关联性', trigger: 'blur' }
        ],
        careerPlan: [
          { required: true, message: '请填写职业规划', trigger: 'blur' }
        ],
        contribution: [
          { required: true, message: '请填写社会贡献', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.requestGetUserInfo();
  },
  methods: {
    requestSubmitUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId,
        data:{
          ...this.formData
        }
      };
      updateUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success('信息提交成功');
          window.location.reload();
        }
      }).catch(err => {
        console.error('提交用户信息失败:', err);
        this.$message.error(err.message || '提交用户信息失败');
      });
    },
    requestGetUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId
      };
      this.loading = true;
      getUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          let data = {}
          try {
            if (res.data && res.data.raw_data) {
              data = JSON.parse(res.data.raw_data);
            }
          } catch (e) {
          }

          this.formData = {
            motivation: data.motivation || '',
            experience: data.experience || '',
            relevance: data.relevance || '',
            careerPlan: data.careerPlan || '',
            contribution: data.contribution || ''
          };
        }

      }).catch(err => {
        console.error('获取用户信息失败:', err);
        this.$message.error(err.message || '获取用户信息失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    // 提交逻辑
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验通过
          this.$message.success('校验通过，正在提交...');
          console.log('最终提交的表单数据:', this.formData);
          this.requestSubmitUserInfo();
          // TODO: 在这里发起 Axios 请求发送给后端
          // axios.post('/api/submit', this.formData)...

        } else {
          // 校验失败
          this.$message.error('请检查表单填写是否完整');
          return false;
        }
      });
    },
    // 重置逻辑
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
.application-form-container {
  max-width: 800px;
  /* 限制最大宽度，防止在大屏上太宽 */
  margin: 30px auto;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.form-header h2 {
  margin-bottom: 10px;
}

.form-header p {
  color: #909399;
  font-size: 14px;
}

.form-footer {
  text-align: center;
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_phd_1.vue